import type { RoutesNamesList } from '@typed-router';

const POKER_PAGE_NAME: RoutesNamesList = 'poker-play';

export const usePoker = () => {
  const { isPokerEnabled } = useFeatureFlagsEnv();

  const { currentRouteName } = useRoutes();

  const isPokerSectionEnabled = computed<boolean>(() => {
    return isPokerEnabled.value;
  });

  const isPokerPage = computed<boolean>(() => {
    return currentRouteName.value === POKER_PAGE_NAME;
  });

  return {
    isPokerSectionEnabled,
    isPokerPage,
  };
};
